import { useEffect, useRef, useState } from "react";
import { icons } from "utils/constants";
import { useSelector } from "react-redux";
import "./Actionmenu.scss";

const Actionmenu = ({
  handleDownloadLog,
  handleApiKey,
  handleEdit,
  handleDelete,
  handleAddNetwork,
  setActionID,
  elem,
}) => {
  const myRef = useRef();
  const reduxData = useSelector((state) => state.global);
  const { isDarkMode } = reduxData || {};
  const [isShow, setIsShow] = useState(false);
  const handleClickOutside = (e) => {
    if (myRef && myRef?.current && !myRef.current.contains(e.target)) {
      setIsShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  });

  return (
    <div id="actionmenu-container">
      <div
        className="fa-center h-20 pointer"
        onClick={() => {
          setIsShow(true);
        }}
      >
        <img
          src={
            isShow
              ? isDarkMode
                ? icons.activeMoreLight
                : icons.activeMore
              : isDarkMode
              ? icons.moreLight
              : icons.more
          }
          alt="more"
          className="fit-image"
        />
      </div>
      {isShow && (
        <div
          className={`${
            isDarkMode ? "menu-option-popup-dark" : "menu-option-popup"
          } shadow`}
          ref={myRef}
        >
          <div
            className="fa-center gap-2 pt-2 pb-2 pointer"
            onClick={() => {
              setIsShow(false);
              handleApiKey();
            }}
          >
            <span className="h-16 d-flex">
              <img
                src={isDarkMode ? icons.keyLight : icons.key}
                alt="key"
                className="fit-image"
              />
            </span>
            <span
              className={`text-12-400 ${
                isDarkMode ? "color-ffff" : "color-2749"
              }`}
            >
              API Key
            </span>
          </div>
          {elem?.type === "unification" ? (
            ""
          ) : (
            <div
              className="fa-center gap-2 pt-2 pb-2 pointer"
              onClick={() => {
                setIsShow(false);
                handleAddNetwork();
              }}
            >
              <span className="h-16 d-flex">
                <img
                  src={icons.Metamaskicon}
                  alt="add"
                  className="fit-image"
                  style={{ color: "black" }}
                />
              </span>
              <span
                className={`text-12-400 ${
                  isDarkMode ? "color-ffff" : "color-2749"
                }`}
              >
                Add Network
              </span>
            </div>
          )}
          <div
            className="fa-center gap-2 pt-2 pb-2 pointer"
            onClick={() => {
              setIsShow(false);
              setActionID({
                project_id: elem.project_id,
                logging: elem.logging,
                apikey: elem.api_key,
              });
            }}
          >
            <span className="h-16 d-flex">
              <img
                src={isDarkMode ? icons.candleLight : icons.candle}
                alt="edit"
                className="fit-image"
              />
            </span>
            <span
              className={`text-12-400 ${
                isDarkMode ? "color-ffff" : "color-2749"
              }`}
            >
              {elem.logging === "true" ? "Disable" : "Enable"} Logging
            </span>
          </div>
          <div
            className="fa-center gap-2 pt-2 pb-2 pointer"
            onClick={() => {
              setIsShow(false);
              handleEdit();
            }}
          >
            <span className="h-16 d-flex">
              <img
                src={isDarkMode ? icons.editLight : icons.edit}
                alt="edit"
                className="fit-image"
              />
            </span>
            <span
              className={`text-12-400 ${
                isDarkMode ? "color-ffff" : "color-2749"
              }`}
            >
              Edit Project
            </span>
          </div>
          <div
            className="fa-center gap-2 pt-2 pb-2 pointer"
            onClick={() => {
              setIsShow(false);
              handleDelete();
            }}
          >
            <span className="h-16 d-flex">
              <img src={icons.trash} alt="trash" className="fit-image" />
            </span>
            <span className="text-12-400 color-4639">Delete Project</span>
          </div>
          <div
            className="fa-center gap-2 pt-2 pb-2 pointer"
            onClick={() => {
              handleDownloadLog();
            }}
          >
            <span className="h-16 d-flex">
              <img src={icons.downloadLog} alt="trash" className="fit-image" />
            </span>
            <span
              className={`text-12-400 ${
                isDarkMode ? "color-ffff" : "color-2749"
              }`}
            >
              Download Log
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Actionmenu;
